import React, { Component } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ConfirmDelete from '../../components/ConfirmDelete'
import { Redirect } from 'react-router-dom'
import Select from '../../components/Select'
import ReactLoading from 'react-loading'
import helper from '../../utils/helper'
import auth from '../../utils/auth'
import cfg from '../../utils/config'
import axios from 'axios'
import './style.css'

const CODIGO_TAMANHO = 6

class Form extends Component {

    state = {
        usuario_perfil: { "timezone": "", "email": "", "imagem_perfil": "", "senha": "", "nome": "" },
        formerrors: [],
        redirect: false,
        path: "",
        optionSelected: { "timezone": {} },
        timezone: [],
        imagem_perfil: "",
        configuracao_existe: false,
        confirma_senha: "",
        cooldown: false,
        tab: 0,
        img_qrcode: "",
        codigoDigits: Array(CODIGO_TAMANHO).fill(""),
        codigoDesativarDigits: Array(CODIGO_TAMANHO).fill(""),
        msg_codigo_desativar_erro: "",
        autenticacao: false,
        delete_autenticacao: false,
        modal: { status: false, message: "" },
        msg_codigo_erro: "",
        loading: false,
        sessoes: [],
        loading_sessoes: false,
        excluindo_sessao: null
    }

    codigoRefs = Array.from({ length: CODIGO_TAMANHO }, () => React.createRef())
    codigoDesativarRefs = Array.from({ length: CODIGO_TAMANHO }, () => React.createRef())

    componentDidMount = () => {
        this.getData()
        this.getSessoes()
    }

    getSessoes = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/usuarios-conectados/'
        const config = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        this.setState({ loading_sessoes: true })

        return axios.get(requestURL, config)
            .then((response) => {
                const sessoes = (response.data.results || []).sort((a, b) => {
                    return Number(b.esta_atual) - Number(a.esta_atual)
                })

                this.setState({ sessoes })
            })
            .catch(() => {
                helper.dispatchEvent("showAviso", {
                    message: "Não foi possível carregar as sessões conectadas."
                })
            })
            .finally(() => this.setState({ loading_sessoes: false }))
    }

    excluirSessao = (id) => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/usuarios-conectados/' + id + '/'
        const config = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        this.setState({ excluindo_sessao: id })

        return axios.delete(requestURL, config)
            .then(() => {
                this.setState((state) => ({
                    sessoes: state.sessoes.filter((sessao) => sessao.id !== id)
                }))

                helper.dispatchEvent("showAviso", {
                    message: "Sessão desconectada com sucesso."
                })
            })
            .catch(() => {
                helper.dispatchEvent("showAviso", {
                    message: "Não foi possível desconectar esta sessão."
                })
            })
            .finally(() => this.setState({ excluindo_sessao: null }))
    }

    getData = () => {
        let requestArray = []
        let userInfo = auth.getUserInfo()
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        requestArray.push(axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/configuracao-timezone/', config_me))
        requestArray.push(axios.get(cfg.base_api_url + cfg.api_v2 + '/me/', config_me))

        axios.all(requestArray)
            .then(axios.spread((timezones, configuracoes) => {
                let optionsTimezones = []
                let usuario_perfil_resp = { "timezone": userInfo['timezone'], "email": userInfo['email'], "imagem_perfil": "", "senha": "", "nome": configuracoes.data.nome }
                let imagem_perfil = ""
                let selectedOption = { "timezone": {} }

                if (timezones.status === 200) {
                    timezones.data.results.forEach((a) => {
                        optionsTimezones.push({ "value": a.codigo, "label": "(" + a.horas + ") " + a.codigo })
                    })
                }

                if (userInfo['timezone']) {
                    const timezoneOption = optionsTimezones.find(
                        timezone => timezone.value === userInfo['timezone']
                    )

                    selectedOption.timezone = timezoneOption || {}
                }

                auth.setUserInfo({ ...userInfo, nome: configuracoes.data.nome }, true)

                imagem_perfil = userInfo['imagem_perfil']

                this.setState({
                    "timezone": optionsTimezones, usuario_perfil: usuario_perfil_resp, imagem_perfil: imagem_perfil, optionSelected: selectedOption, autenticacao: configuracoes.data.ativo_2fa, delete_autenticacao: configuracoes.data.ativo_2fa
                })
            }))
    }

    handleChangeSistema = (e) => {
        let obj = this.state.usuario_perfil
        obj[e.target.id] = e.target.value
        this.setState({ "usuario_perfil": obj })
    }

    handleChangePerfil = (e) => {
        let obj = this.state.usuario_perfil
        obj[e.target.id] = e.target.files[0]
        if (e.target.files[0])
            this.setState({ "usuario_perfil": obj, imagem_perfil: URL.createObjectURL(e.target.files[0]) })
    }

    handleChangeSelect = (selectedOption, field) => {
        let obj = this.state.usuario_perfil
        obj[field] = selectedOption.value
        let optionObj = this.state.optionSelected
        optionObj[field] = selectedOption
        this.setState({ "optionSelected": optionObj, "usuario_perfil": obj })
    }

    handleChangeAutenticacao = async (checked) => {
        this.setState({ loading: true })

        if (checked) {
            this.setState({ autenticacao: checked })
            await this.gerarQrcode()
        } else {
            await this.validarCodigoDesativacao()
        }

        this.setState({ loading: false })
    }

    handleCodigoDigitChange = (stateKey, refsKey, index, e) => {
        let valor = e.target.value.slice(-1)
        let digits = [...this.state[stateKey]]
        digits[index] = valor

        this.setState({ [stateKey]: digits })

        if (valor && index < CODIGO_TAMANHO - 1) {
            const proximo = this[refsKey][index + 1].current
            if (proximo) proximo.focus()
        }
    }

    handleCodigoDigitKeyDown = (stateKey, refsKey, index, onEnter, e) => {
        if (e.key === 'Backspace' && !this.state[stateKey][index] && index > 0) {
            const anterior = this[refsKey][index - 1].current
            if (anterior) anterior.focus()
        } else if (e.key === 'Enter' && onEnter) {
            onEnter()
        }
    }

    handleCodigoPaste = (stateKey, refsKey, index, e) => {
        e.preventDefault()

        let pasted = (e.clipboardData || window.clipboardData).getData('text').trim()
        if (!pasted) return

        let chars = pasted.split('')
        let digits = [...this.state[stateKey]]

        for (let i = 0; i < chars.length && (index + i) < CODIGO_TAMANHO; i++) {
            digits[index + i] = chars[i]
        }

        this.setState({ [stateKey]: digits })

        let ultimoIndex = Math.min(index + chars.length, CODIGO_TAMANHO) - 1
        const ultimoRef = ultimoIndex >= 0 ? this[refsKey][ultimoIndex].current : null
        if (ultimoRef) ultimoRef.focus()
    }

    validation_confirmPassword = () => {
        const { usuario_perfil, confirma_senha } = this.state
        let erro = false

        if (usuario_perfil.senha != "") {
            if (usuario_perfil.senha != confirma_senha) {
                erro = true
            }
        }

        return erro
    }

    gerarQrcode = () => {
        let requestURL = cfg.base_api_url + cfg.api_v2 + "/2fa/"
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        return axios.get(requestURL, config_me)
            .then((response) => {
                this.setState({ img_qrcode: response.data.qrcode })
            })
    }

    cancelarConfiguracao2fa = () => {
        this.setState({ img_qrcode: "", codigoDigits: Array(CODIGO_TAMANHO).fill(""), msg_codigo_erro: "", autenticacao: false })
    }

    testQrcode = () => {
        let bodyFormData = new FormData()
        bodyFormData.append('codigo', this.state.codigoDigits.join(''))

        axios({
            method: "POST",
            url: cfg.base_api_url + cfg.api_v2 + "/2fa/",
            data: bodyFormData,
            headers: { 'Authorization': 'Bearer ' + auth.getToken() }
        })
            .then((response) => {
                helper.dispatchEvent("showAviso", {
                    message: response.data.message,
                    callback: () => { this.setState({ img_qrcode: "", delete_autenticacao: true, codigoDigits: Array(CODIGO_TAMANHO).fill("") }) }
                })
            })
            .catch((error) => {
                this.setState({ msg_codigo_erro: error.response.data.message })
            })
    }

    excluirValidacao = () => {
        return axios({
            method: 'PATCH',
            url: cfg.base_api_url + cfg.api_v2 + '/me/',
            data: JSON.stringify({ "ativo_2fa": false }),
            headers: { 'Authorization': 'Bearer ' + auth.getToken(), 'Content-Type': 'application/json' }
        })
            .then(() => {
                this.setState({ img_qrcode: "", delete_autenticacao: false })
            })
    }

    validarCodigoDesativacao = () => {
        let bodyFormData = new FormData()
        bodyFormData.append('codigo', this.state.codigoDesativarDigits.join(''))

        return axios({
            method: "POST",
            url: cfg.base_api_url + cfg.api_v2 + "/2fa/",
            data: bodyFormData,
            headers: { 'Authorization': 'Bearer ' + auth.getToken() }
        })
            .then(() => {
                this.setState({ codigoDesativarDigits: Array(CODIGO_TAMANHO).fill(""), msg_codigo_desativar_erro: "", autenticacao: false })
                return this.excluirValidacao()
            })
            .catch((error) => {
                this.setState({ msg_codigo_desativar_erro: error.response.data.message })
            })
    }

    saveAction = async () => {
        if (this.validation_confirmPassword()) {
            this.setState({ tab: 1, modal: { status: true, message: "Confirmação de senha inválida!" } })
            return
        }

        this.setState({ cooldown: true })
        let requestURL = ''
        let verb = ''

        verb = 'patch'

        requestURL = cfg.base_api_url + cfg.api_v2 + '/me/'

        let bodyFormData = new FormData()

        for (let key in this.state.usuario_perfil) {
            bodyFormData.append(key, this.state.usuario_perfil[key])
        }

        if(this.state.usuario_perfil.senha === "") {
            bodyFormData.delete("senha")
        }   

        await axios({
            method: verb,
            url: requestURL,
            data: bodyFormData,
            headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + auth.getToken() }
        })
        .then((res) => {
            let userInfo = auth.getUserInfo()
            userInfo.imagem_perfil = res.data.imagem_perfil
            userInfo.timezone = res.data.timezone
            userInfo.nome = res.data.nome
            userInfo.email = res.data.usuario__username

            auth.setUserInfo(userInfo, true)

            helper.dispatchEvent("showAviso", {
                message: "Configurações salvas.",
                callback: () => { window.location.reload() }
            })
        })
        .catch(console.error)

        this.setState({ cooldown: false })
    }

    render() {
        const timezone = this.state.optionSelected.timezone
        const modal = this.state.modal
        const { img_qrcode, delete_autenticacao, loading, codigoDigits, codigoDesativarDigits, msg_codigo_desativar_erro, sessoes, loading_sessoes, excluindo_sessao } = this.state

        if (this.state.redirect === true) {
            return <Redirect to={this.state.path} />
        }

        return (
            <div>
                <Modal isOpen={modal.status} toggle={() => this.setState({ modal: { status: false, message: "" } })}>
                    <ModalHeader>
                        Aviso
                    </ModalHeader>
                    <ModalBody>
                        <span>{modal.message}</span>
                    </ModalBody>
                    <ModalFooter>
                        <button onClick={() => this.setState({ modal: { status: false, message: "" } })} className="hdv-btn-forms hdv-btn-red">Fechar</button>
                    </ModalFooter>
                </Modal>
                <div>
                    <div className="hdv-default-header mx-3">
                        <span className="screen-menu-desc">
                            <h4>Minha Conta</h4>
                            <div className="gray-background">
                                <i className="fa fa-user fa-2x"></i>
                            </div>
                        </span>
                    </div>
                </div>

                <Tabs className="tabs-style" selectedIndex={this.state.tab} onSelect={(i) => this.setState({ tab: i })}>
                    <TabList>
                        <Tab>Meus Dados</Tab>
                        <Tab>Senha</Tab>
                        <Tab>Autenticação</Tab>
                        <Tab>Sessões</Tab>
                    </TabList>

                    <TabPanel>
                        <form className="hdv-form-default row">
                            <div className="hdv-file-picker col-md-4">
                                <label>Imagem de Perfil</label>
                                <img style={{width: "200px"}} className={(this.state.imagem_perfil) ? "hdv-logomarca-preview" : "hdv-noshow-item"} srcSet={this.state.imagem_perfil} alt="Perfil Preview" />
                                <br />
                                <input type="file" name="imagem_perfil" id="imagem_perfil" onChange={this.handleChangePerfil} />
                                <label htmlFor="imagem_perfil">Selecionar arquivo</label>
                            </div>
                            <div className="col-md-8">
                                <label htmlFor="nome">Nome</label>
                                <input type="text" name="nome" id="nome" value={this.state.usuario_perfil.nome} onChange={this.handleChangeSistema} />

                                <label htmlFor="email">E-mail</label>
                                <input type="text" name="email" id="email" value={this.state.usuario_perfil.email} onChange={this.handleChangeSistema} />

                                <label htmlFor="timezone">Timezone</label>
                                <Select
                                    value={timezone}
                                    onChange={(e) => this.handleChangeSelect(e, 'timezone')}
                                    options={this.state.timezone}
                                />
                            </div>
                        </form>
                    </TabPanel>

                    <TabPanel>
                        <form className="hdv-form-default">
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="senha">Nova Senha</label>
                                    <input className="hdv-form-system-password-field" type="password" name="senha" id="senha" value={this.state.usuario_perfil.senha} onChange={this.handleChangeSistema} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="confirma_senha">Confirmar Nova Senha</label>
                                    <input className="hdv-form-system-password-field" type="password" name="confirma_senha" id="confirma_senha" value={this.state.confirma_senha} onChange={(e) => this.setState({ confirma_senha: e.target.value })} />
                                </div>
                            </div>
                        </form>
                    </TabPanel>
                    <TabPanel>
                        <div className="hdv-form-default">
                            <div className="mc-2fa-wrapper">
                                <div className={'row mc-2fa-initial' + (delete_autenticacao ? ' mc-2fa-hidden' : '')}>
                                    <div className='col-md-12'>
                                        <label className="mc-2fa-title">Autenticação de dois fatores</label>
                                        <p className="text-muted mc-2fa-desc">
                                            Proteja sua conta adicionando uma camada extra de segurança. Após ativar, será necessário informar um código temporário gerado em um aplicativo autenticador durante o login.
                                        </p>
                                        <button
                                            disabled={loading}
                                            onClick={() => img_qrcode ? this.cancelarConfiguracao2fa() : this.handleChangeAutenticacao(true)}
                                            className={'hdv-btn-forms ' + (img_qrcode ? 'hdv-btn-red' : 'hdv-btn-green')}>
                                            {img_qrcode ? 'Cancelar' : 'Habilitar'}
                                        </button>
                                    </div>
                                </div>

                                <div className={'row mc-2fa-active' + (delete_autenticacao ? '' : ' mc-2fa-hidden')}>
                                    <div className='col-md-12'>
                                        <p className="mc-2fa-success">✓ Autenticação de dois fatores ativada com sucesso.</p>
                                        <p className="text-muted mc-2fa-desc">Seu aplicativo autenticador já está vinculado à sua conta.</p>

                                        <div className="mc-2fa-divider">
                                            <label className="mc-2fa-title">Desativar autenticação de dois fatores</label>
                                            <p className="text-muted mc-2fa-desc">
                                                Por segurança, informe abaixo o código de 6 dígitos gerado pelo aplicativo autenticador para confirmar a desativação.
                                            </p>
                                            <div className="mc-2fa-visual-center">
                                                <div className="mc-2fa-code-actions">
                                                    <div className="codigo-input-group">
                                                        {codigoDesativarDigits.map((digito, index) => (
                                                            <input
                                                                key={index}
                                                                ref={this.codigoDesativarRefs[index]}
                                                                type="text"
                                                                inputMode="text"
                                                                maxLength={1}
                                                                autoComplete="off"
                                                                value={digito}
                                                                onChange={(e) => { this.handleCodigoDigitChange('codigoDesativarDigits', 'codigoDesativarRefs', index, e); this.setState({ msg_codigo_desativar_erro: "" }) }}
                                                                onKeyDown={(e) => this.handleCodigoDigitKeyDown('codigoDesativarDigits', 'codigoDesativarRefs', index, () => this.handleChangeAutenticacao(false), e)}
                                                                onPaste={(e) => this.handleCodigoPaste('codigoDesativarDigits', 'codigoDesativarRefs', index, e)}
                                                            />
                                                        ))}
                                                    </div>
                                                    <button
                                                        disabled={codigoDesativarDigits.join('').length < CODIGO_TAMANHO}
                                                        onClick={() => this.handleChangeAutenticacao(false)}
                                                        className='hdv-btn-forms hdv-btn-red mc-2fa-code-btn'>
                                                        Desativar autenticação
                                                    </button>
                                                </div>
                                            </div>
                                            <span id='validacao-codigo-desativar'>{msg_codigo_desativar_erro}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={'row mc-2fa-loading' + (loading ? '' : ' mc-2fa-hidden')}>
                                    <ReactLoading className="var(--background-menu)" type="cylon" color={"#589bd4"} width={50} />
                                </div>

                                <details open={true} className={'custom-summary mc-2fa-details' + (img_qrcode != "" ? '' : ' mc-2fa-hidden')}>
                                    <summary>Configurar autenticação de dois fatores</summary>
                                    <div className="mc-2fa-details-body">
                                        <div className="row mc-2fa-step-row">
                                            <div className="col-md-7">
                                                <label className="mc-2fa-step-title">1. Instale um aplicativo autenticador</label>
                                                <p className="text-muted mc-2fa-step-desc">
                                                    Utilize qualquer aplicativo autenticador compatível, como Google Authenticator, Microsoft Authenticator, Authy ou 2FAS.
                                                </p>
                                                <span className="mc-2fa-step-note">Caso já possua um aplicativo autenticador instalado, prossiga para o próximo passo.</span>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="mc-2fa-visual-center">
                                                    <div className="mc-2fa-visual-box">
                                                        <div className="mc-2fa-icon-wrap">
                                                            <i className="fa fa-mobile fa-8x mc-2fa-icon-phone"></i>
                                                            <i className="las la-user-shield la-4x mc-2fa-icon-shield"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mc-2fa-step-row">

                                            <div className="col-md-7">
                                                <label className="mc-2fa-step-title">2. Escaneie o QR Code</label>
                                                <p className="text-muted mc-2fa-step-desc">
                                                    Abra o aplicativo autenticador, toque em "+" e escolha a opção para escanear um QR Code.
                                                </p>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="mc-2fa-visual-center">
                                                    <div className="mc-2fa-visual-box">
                                                        <img className="mc-2fa-qr-img" src={`data:image/jpeg;base64,${this.state.img_qrcode}`} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mc-2fa-step-row-last">
                                            <div className="col-md-7">
                                                <label className="mc-2fa-step-title">3. Confirme a configuração</label>
                                                <p className="text-muted mc-2fa-step-desc">
                                                    Digite abaixo o código de 6 dígitos exibido pelo aplicativo autenticador.
                                                </p>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="mc-2fa-visual-center">
                                                    <div className="mc-2fa-code-actions">
                                                        <div className="codigo-input-group">
                                                            {codigoDigits.map((digito, index) => (
                                                                <input
                                                                    key={index}
                                                                    ref={this.codigoRefs[index]}
                                                                    type="text"
                                                                    inputMode="text"
                                                                    maxLength={1}
                                                                    autoComplete="off"
                                                                    value={digito}
                                                                    onChange={(e) => { this.handleCodigoDigitChange('codigoDigits', 'codigoRefs', index, e); this.setState({ msg_codigo_erro: "" }) }}
                                                                    onKeyDown={(e) => this.handleCodigoDigitKeyDown('codigoDigits', 'codigoRefs', index, this.testQrcode, e)}
                                                                    onPaste={(e) => this.handleCodigoPaste('codigoDigits', 'codigoRefs', index, e)}
                                                                />
                                                            ))}
                                                        </div>
                                                        <button onClick={this.testQrcode} className='hdv-btn-forms hdv-btn-blue mc-2fa-code-btn'>Confirmar ativação</button>
                                                    </div>
                                                </div>
                                                <div className="mc-2fa-code-note">
                                                    <small className="text-muted">O código é atualizado automaticamente a cada 30 segundos.</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </details>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="hdv-form-default">
                            <div className={loading_sessoes ? "afira-table-content afira-table-loading" : "afira-table-content"} data-message="Carregando sessões..." style={{ minHeight: loading_sessoes ? "180px" : "auto" }}>
                                <table className="table afira-table">
                                    <thead>
                                        <tr>
                                            <th>Dispositivo</th>
                                            <th>Navegador</th>
                                            <th>Localização</th>
                                            <th>Primeiro acesso</th>
                                            <th>Último acesso</th>
                                            <th className="hdv-subtable-action-td text-center">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!loading_sessoes && sessoes.length === 0 && (
                                            <tr>
                                                <td colSpan="6" className="text-center">Nenhuma sessão conectada encontrada.</td>
                                            </tr>
                                        )}
                                        {sessoes.map((sessao) => (
                                            <tr key={sessao.id}>
                                                <td>
                                                    {sessao.dispositivo}
                                                    {sessao.esta_atual && <span className="ml-2 badge badge-success">Sessão atual</span>}
                                                </td>
                                                <td>{sessao.navegador}</td>
                                                <td>{[sessao.cidade, sessao.estado, sessao.pais].filter(Boolean).join(', ') || 'Desconhecida'}</td>
                                                <td>{new Date(sessao.primeiro_acesso).toLocaleString('pt-BR')}</td>
                                                <td>{sessao.ultimo_acesso_relativo || new Date(sessao.ultimo_acesso).toLocaleString('pt-BR')}</td>
                                                <td className="hdv-subtable-action-td text-center">
                                                    {sessao.esta_atual ? (
                                                        <span style={{ color: "#777", fontSize: "12px" }}>Em uso</span>
                                                    ) : (
                                                        <ConfirmDelete
                                                            enabled={excluindo_sessao !== sessao.id}
                                                            action={() => this.excluirSessao(sessao.id)}
                                                            label={excluindo_sessao === sessao.id ? "Desconectando..." : "Desconectar"}
                                                        />
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </TabPanel>
                </Tabs>
                <div style={{ display: this.state.tab >= 2 ? "none" : "block" }} className="hdv-btn-group">
                    <button disabled={this.state.cooldown} onClick={() => this.saveAction()} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                </div>
            </div>
        )
    }
}

export default Form